import Wapprunner from './root'
import { WapprunnerCreate } from '../components/wapprunner-create'
import {
  generateWappElementName,
  generateWappSessionId,
  WappSession,
  WappSessionCreator,
  WappParentType,
  WappParent,
  WappStage,
} from '../common'
import {
  addToConnectedWapps,
  removeFromConnectedWapps,
  isWappConnected,
} from '../wapprunner-pool/connected-wapps'
import {
  findConnectedWapp,
  findRunningWapp,
  getWappSession,
  getWappSessions,
  getWappSessionsByWappId,
  getWappSessionsByWisId,
  getWappSessionByWappIdAndWisId,
} from '../wapprunner-pool/wapprunnerPool.helper'
import {
  getWappInput,
  getWappOutput,
  removeFromWappPool,
  restartWappSession,
  setWappBookmarkData,
  setWappCustomActions,
  setWappStage,
  setWappOutput,
} from '../wapprunner-pool/wapprunnerPool.ops'
import {
  useWappBookmarkData,
  useWappCustomActions,
  useWappStage,
} from '../react-hooks'
import { Listeners } from '../listeners'

const wapprunnerStart = setWappStage(WappStage.RUNNING)
const wapprunnerRemove = removeFromWappPool
const findRunningWappInRightPanel = (): WappSession => null
export const { listen } = Listeners
export { WappRunnerEvent } from '../listeners'

export default Wapprunner

export type { WappParent }

export {
  WappStage,
  WappSession,
  WappSessionCreator,
  WappParentType,
  WapprunnerCreate,
  restartWappSession,
  wapprunnerStart,
  wapprunnerRemove,
  generateWappElementName,
  generateWappSessionId,
  findRunningWapp,
  findConnectedWapp,
  getWappSession,
  getWappSessions,
  findRunningWappInRightPanel,
  addToConnectedWapps,
  removeFromConnectedWapps,
  isWappConnected,
  getWappSessionsByWappId,
  getWappSessionsByWisId,
  getWappSessionByWappIdAndWisId,
  getWappInput,
  getWappOutput,
  setWappCustomActions,
  setWappOutput,
  useWappStage,
  useWappCustomActions,
  useWappBookmarkData,
  setWappBookmarkData,
}

type Analite = (
  type: string,
  data?: Record<string, unknown>,
  persist?: boolean,
  timestamp?: number,
) => void

declare global {
  // eslint-disable-next-line no-var,vars-on-top
  var analite: Analite

  var analiteImmediatly: Analite

  var config: { env: any; frontend: any }
}
